// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3DdDl","assignButton":"CreateEditEquipmentSchedule_assignButton__vy7Ye"};